import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {StoreModule} from '@ngrx/store';
import {reducers} from './funkprotokollierung.reducer';
import {EffectsModule} from '@ngrx/effects';
import {FunkprotokollierungPageUiEffects} from './funkprotokollierung.effects.ui';
import {NotificationService} from '@orga-app/providers/notification.service';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {FunkprotokollierungPage} from './funkprotokollierung.page';
import {FunkprotokollierungPageRoutingModule} from './funkprotokollierung-routing.module';
import {
    VeranstaltungenFunkprotokollEffects,
    VeranstaltungenFunkprotokollEintragEntfernenEffects,
    VeranstaltungenFunkprotokollEintragErfassenEffects,
    VeranstaltungenFunkprotokollExcelEffects,
    VeranstaltungenFunkprotokollFallAbschliessenEffects, VeranstaltungenFunkprotokollFallEntfernenEffects,
    VeranstaltungenFunkprotokollFallErfassenEffects, VeranstaltungenFunkprotokollFallErinnerungSetzenEffects,
    VeranstaltungenFunkprotokollFallReaktivierenEffects, VeranstaltungenFunkprotokollMeldeartListeEffects, VeranstaltungenFunkprotokollVorlagenListeEffects
} from '../../../client-ngrx/veranstaltungen';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';
import {FunkprotokollierungPageWsEffects} from './funkprotokollierung.effects.ws';
import {SopiDirectivesModule} from '../../../sopi/directives/sopi-directives.module';
import {ErinnerungPopoverModule} from './erinnerung-popover/erinnerung-popover.module';
import {ComponentsModule} from '../../../sopi/components/components.module';
import {IncidentsIncidentAnlegenAusFunkprotokollEffects, IncidentsIncidentByFunkprotokollFallEffects} from '../../../client-ngrx/incidents';
import {PipesSharedModule} from '../../shared/pipes/pipes-shared.module';

@NgModule({
    declarations: [
        FunkprotokollierungPage,
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FunkprotokollierungPageRoutingModule,

        StoreModule.forFeature('FunkprotokollierungPage', reducers),

        EffectsModule.forFeature([
            FunkprotokollierungPageUiEffects,
            FunkprotokollierungPageWsEffects,
            VeranstaltungenFunkprotokollEffects,
            VeranstaltungenFunkprotokollExcelEffects,
            VeranstaltungenFunkprotokollFallErfassenEffects,
            VeranstaltungenFunkprotokollFallAbschliessenEffects,
            VeranstaltungenFunkprotokollFallReaktivierenEffects,
            VeranstaltungenFunkprotokollFallEntfernenEffects,
            VeranstaltungenFunkprotokollEintragErfassenEffects,
            VeranstaltungenFunkprotokollEintragEntfernenEffects,
            VeranstaltungenFunkprotokollFallErinnerungSetzenEffects,
            VeranstaltungenFunkprotokollMeldeartListeEffects,

            VeranstaltungenFunkprotokollVorlagenListeEffects,

            IncidentsIncidentByFunkprotokollFallEffects,

            IncidentsIncidentAnlegenAusFunkprotokollEffects
        ]),
        ReactiveFormsModule,
        SopiScrollModule,
        ErinnerungPopoverModule,
        ComponentsModule,
        SopiComponentsModule.forRoot(),
        SopiDirectivesModule.forRoot(),
        PipesSharedModule,
    ],
    providers: [
        NotificationService,
    ],
    entryComponents: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class FunkprotokollierungPageModule {

}
